import {gsap} from "gsap";

$(document).ready(function () {

    const isMobile = window.innerWidth < 840;
    // Configuración base de sliders
    const defaultSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 840,
                settings: {}
            }
        ]
    };

    // Función para inicializar cualquier slider y actualizar su contador si existe
    function initSlider(selector, settings = defaultSettings) {
        const $slider = $(selector);

        if ($slider.length) {
            $slider.on('init afterChange', function (event, slick, currentSlide) {
                let slideIndex = (currentSlide !== undefined ? currentSlide : 0) + 1;
                let totalSlides = slick.slideCount;

                // Buscar el contenedor del slider
                const $galleryContainer = $slider.closest('.gallery');

                // Solo actualizar el contador si existen los elementos en el contenedor
                const $countCurrent = $galleryContainer.find('.count-current');
                const $countTotal = $galleryContainer.find('.count-total');

                if ($countCurrent.length && $countTotal.length) {
                    $countCurrent.text(slideIndex);
                    $countTotal.text(totalSlides);
                }
            });

            $slider.slick(settings);
        }
    }

    function attachArrowTooltip(sliderSelector) {
        // Primero: definimos la función que crea y gestiona el tooltip
        // 1) Creamos el tooltip y lo añadimos al body (oculto inicialmente)
        const tooltip = document.createElement('div');
        tooltip.classList.add('tooltip-text');
        document.body.appendChild(tooltip);

        // 2) Funciones para mostrar/posicionar/ocultar el tooltip
        function onArrowMouseEnter(e) {
            const arrow = e.currentTarget;
            // Si la flecha está deshabilitada, no hacemos nada
            if (arrow.classList.contains('slick-disabled')) return;

            const text = arrow.innerText.trim();
            if (!text) return;

            tooltip.textContent = text;
            gsap.killTweensOf(tooltip);
            gsap.to(tooltip, { opacity: 1, duration: 0.2 });
            positionTooltip(e);
        }

        function positionTooltip(e) {
            const x = e.clientX;
            const y = e.clientY;
            gsap.to(tooltip, {
                x: x,
                y: y,
                duration: 0.1,
                ease: 'power3.out'
            });
        }

        function onArrowMouseLeave() {
            gsap.killTweensOf(tooltip);
            gsap.to(tooltip, { opacity: 0, duration: 0.15 });
        }

        // 3) Cuando el slider se inicialice (evento 'init'), enlazamos los eventos
        $(sliderSelector)
            .on('init', function() {
                const arrows = document.querySelectorAll(
                    sliderSelector + ' .slick-prev, ' +
                    sliderSelector + ' .slick-next'
                );
                arrows.forEach(arrow => {
                    arrow.addEventListener('mouseenter', onArrowMouseEnter);
                    arrow.addEventListener('mousemove', positionTooltip);
                    arrow.addEventListener('mouseleave', onArrowMouseLeave);
                });
            })
            // 4) Finalmente, lanzamos el init real de Slick a través de initSlider
            .slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
                centerMode: true,
                centerPadding: '0px',
                prevArrow: '<button type="button" class="slick-prev">anterior imagen</button>',
                nextArrow: '<button type="button" class="slick-next">siguiente imagen</button>',
                responsive: [
                    {
                        breakpoint: 840,
                        settings: {
                            slidesToShow: 1.6,
                            slidesToScroll: 1,
                            centerMode: false,
                            arrows: false,
                            infinite: false
                        }
                    }
                ]
            });
    }

    if (document.body.classList.contains('single-project')) {
        if (!isMobile) {
            attachArrowTooltip('.project-content__gallery--slider');
        }
        if (isMobile) {
            initSlider('.project-content__gallery--slider', {
                dots: false,
                centerPadding: '0px',
                responsive: [
                    {
                        breakpoint: 840,
                        settings: {
                            slidesToShow: 1.6,   // 1 completa + 0.8 de la siguiente
                            slidesToScroll: 1,
                            centerMode: false,   // muy importante: sin centrar
                            arrows: false,
                            infinite: false
                        }
                    }
                ]
            });
            initSlider('.project-related__slider', {
                responsive: [
                    {
                        breakpoint: 840,
                        settings: {
                            slidesToShow: 1.6,   // 1 completa + 0.8 de la siguiente
                            slidesToScroll: 1,
                            centerMode: false,   // muy importante: sin centrar
                            arrows: false,
                            infinite: false,
                            variableWidth: true
                        }
                    }
                ]
            });
        }
    }
});


